import React, { useEffect, useState, useContext, useRef, useCallback } from 'react';
import "./EmployeeDashboardMob.css";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { UserContext } from './UserContext';
import { Button, TextField, Container } from '@mui/material';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import Switch from '@mui/material/Switch';
import FilterInterviewsMob from './FilterInterviewsMob';
import EmployeeChats from './EmployeeChats';
import { ContactButton } from "./ContactButton";
import { useSocket } from '../SocketContext';
import ScheduleInterviewUI from './ScheduleInterviewUI';
import ApplicantPopup from './ApplicantPopup';
import TimeUtilizationReport from './TimeUtilizationReport';

const stopModalStyle = {
  position: 'relative',
  margin: "auto",
  height: "auto",
  minWidth: 325,
  maxWidth: 385,
  scrollY: "auto",
  bgcolor: 'background.paper',
  border: '2px solid #000',
};

const EmployeeDashboardMob = (props) => {
  const { callUser, stopCall, remoteVideo } = useSocket();

  // State Declarations
  const [rowData, setRowData] = useState([]);
  const [fromDate, setFromDate] = useState(new Date().toISOString().substring(0, 10));
  const [toDate, setToDate] = useState(new Date().toISOString().substring(0, 10));
  const [loadTime, setLoadTime] = useState(new Date());
  const [selectedRow, setSelectedRow] = useState();
  const { user, setUser } = useContext(UserContext);
  const [searchData, setSearchData] = useState("");
  const [openShedule, setOpenScedule] = useState(false);
  const [openApplicant, setOpenApplicant] = useState(false);
  const [open, setOpen] = useState(false);
  const [data, setData] = useState("mobile");

  const [isCallingActive, setIsCallingActive] = useState(false);
  const [stopComments, setStopComments] = useState("");
  const [openStopModel, setOpenStopModel] = useState(false);
  const [userStatusId, setUserStatusId] = useState("");
  const [result, setResult] = useState([]);
  const [reportOpen, setReportOpen] = useState(false);
  const [reportUserId, setReportUserId] = useState(null);
  const [reportUserName, setReportUserName] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  // Timer State
  const [sessionSeconds, setSessionSeconds] = useState(0);

  const alertStart = useRef(new Date());
  const hasStartedCalling = useRef(false);
  const [callFilterText, setCallFilterText] = useState("Graduate");
  const [filterCallsByEducation, setFilterCallsByEducation] = useState(false);
  const [settingFilter, setSettingFilter] = useState(false);
  const [chattingView, setChattingView] = useState(false);

  // Hardware Permissions States
  const [camAllowed, setCamAllowed] = useState(false);
  const [micAllowed, setMicAllowed] = useState(false);
  const [activeAdmin, setActiveAdmin] = useState(false);

  // Sync ref for instantaneous hardware evaluations within closures
  const micAllowedRef = useRef(false);

  // =========================================================
  // ✅ 1. STABLE FUNCTION REFS (Prevents Child Component API Spam)
  // =========================================================

  const loadCurrentDataRef = useRef();
  const showCandidateRef = useRef();
  const msgCandidateRef = useRef();

  // =========================================================
  // ✅ 2. HELPER FUNCTIONS & API CALLS
  // =========================================================

  const checkIdle = () => {
    if ((isCallingActive === true) && ((new Date() - alertStart.current) > 300000)) {
      setOpen(true);
      setTimeout(() => checkIdle(), 30000);
    }
  };

  const addApplicants = () => setOpenApplicant(true);

  // Format Timer Helper
  const formatSessionTimer = (totalSeconds) => {
    if (isNaN(totalSeconds) || totalSeconds < 0) return "00:00:00";
    const h = Math.floor(totalSeconds / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    const s = totalSeconds % 60;
    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  };

  function max_of_three(x, y, z, a, b, c, d, e, f) {
    let max_val = x;
    if (y && y.length > max_val.length) max_val = y;
    if (z && z.length > max_val.length) max_val = z;
    if (a && a.length > max_val.length) max_val = a;
    if (b && b.length > max_val.length) max_val = b;
    if (c && c.length > max_val.length) max_val = c;
    if (d && d.length > max_val.length) max_val = d;
    if (e && e.length > max_val.length) max_val = e;
    if (f && f.length > max_val.length) max_val = f;
    return max_val;
  }

  const SearchCandidate = () => {
    let apiURL = process.env.REACT_APP_API_URL + "/interview/getinterviewbysearch/" + searchData;
    let apiParams = {
      method: "GET",
      headers: {
        searchBy: data,
        authtoken: localStorage.getItem("loggedintoken")
      }
    };

    fetch(apiURL, apiParams)
      .then((res) => (res.status === 200 ? res.json() : res.text()))
      .then((repos) => {
        if (repos.data) {
          if (repos.data.length === 1) {
            const interview = repos.data[0];
            let IntvwTime = interview.interviewtime ? ((interview.interviewtime).length < 6 ? (interview.interviewtime) : new Date((interview.interviewtime)).toTimeString().slice(0, 5)) : new Date().toTimeString().slice(0, 5);

            setSelectedRow({
              id: interview?._id,
              applicantid: interview?.applicantId,
              jobid: interview?.jobId,
              name: interview?.name,
              mobile: interview?.mobile,
              jobtitle: interview?.jobtitle,
              companyname: interview?.companyname,
              interviewername: interview?.interviewername,
              timespent: interview?.timeSpent,
              hrname: (interview.hrname && interview.hrname !== "undefined") ? interview.hrname : "",
              interviewdate: interview?.interviewdate && (new Date(interview?.interviewdate)),
              interviewtime: IntvwTime,
              status: interview?.status.replace("Nextround", "Passed").replace("Next Round", "Passed"),
              feedback: interview?.feedback,
              bookmark: (interview.bookmark && interview.bookmark !== "undefined") ? interview.bookmark : false,
            });

            if (!micAllowedRef.current) {
              props.showAlert("Cannot open interview. Microphone is muted or unavailable.", "error");
            } else {
              setOpenScedule(true);
            }
          } else {
            window.isIntentionalRedirect = true;
            window.location.href = "/interviewdetails?selectedCell=" + ([data, user._id, searchData]);
          }
        } else props.showAlert("" + (repos.message || repos), "error");
      })
      .catch((err) => props.showAlert(('' + err), "error"));
  };

  const showCandidate = (candidate, hr) => {
    var filters = localStorage.getItem("filters");
    let apiURL = "";
    if (candidate === "new" && user.accesstype == 5) {
      apiURL = process.env.REACT_APP_API_URL + "/interview/newverification/" + hr;
    } else if (filterCallsByEducation === true && candidate === "new" && user.accesstype != 5) {
      apiURL = process.env.REACT_APP_API_URL + "/interview/newinterviewfilter/" + hr + "/" + callFilterText;
    } else if (candidate === "new" && user.accesstype != 5) {
      apiURL = process.env.REACT_APP_API_URL + "/interview/newinterviewfilter/" + hr;
    } else {
      apiURL = process.env.REACT_APP_API_URL + "/interview/getinterview/" + candidate;
    }

    let apiParams = {
      method: "GET",
      headers: {
        filters: filters,
        authtoken: localStorage.getItem("loggedintoken")
      }
    };

    fetch(apiURL, apiParams)
      .then((res) => (res.status === 200 ? res.json() : res.text()))
      .then((repos) => {
        if (repos.data) {
          const interview = repos.data;
          setSelectedRow({
            id: interview?._id,
            applicantid: interview?.applicantId,
            jobid: interview?.jobId,
            name: interview?.name,
            mobile: interview?.mobile,
            status: interview?.status.replace("Nextround", "Passed").replace("Next Round", "Passed"),
          });

          if (!micAllowedRef.current) {
            props.showAlert("Cannot open interview. Microphone is muted or unavailable.", "error");
          } else {
            setOpenScedule(true);
          }
        } else props.showAlert("No data available for selected filters!", "error");
      })
      .catch((err) => props.showAlert(('' + err), "error"));
  };

  const msgCandidate = (candidate, hr) => {
    var filters = localStorage.getItem("filters");
    let apiURL = "";
    if (candidate === "new" && user.accesstype == 5) {
      apiURL = process.env.REACT_APP_API_URL + "/interview/newverification/" + hr;
    } else {
      apiURL = process.env.REACT_APP_API_URL + "/interview/getinterview/" + candidate;
    }

    let apiParams = {
      method: "GET",
      headers: { filters: filters, authtoken: localStorage.getItem("loggedintoken") }
    };

    fetch(apiURL, apiParams)
      .then((res) => (res.status === 200 ? res.json() : res.text()))
      .then((repos) => {
        if (repos.data) {
          const rowDataLocal = repos.data;
          let whatsappURL = "https://" + (user.device === "mobile" ? "api" : "web") + ".whatsapp.com/send/?phone=+91" + rowDataLocal.mobile.trim().replace(' ', '').substring(rowDataLocal.mobile.trim().replace(' ', '').length - 10) + "&type=phone_number&app_absent=0&text=Good Day " + rowDataLocal.name + ",%0a%0aI am contacting you for a job vacancy (Work from Office). Please let me know the best time to call you.%0a%0aMy name is " + user.name + ", I am from Bizi Bees Outsourcing Private Limited. You can call me on " + user.phone + " as well at your convenient time to discuss about the vacancy.%0a%0aPlease follow us on our LinkedIn page url below for latest updates.%0a%0ahttps://www.linkedin.com/company/bizi-bees-outsourcing";

          window.open(whatsappURL, '_blank');
          UpdateMessagedStatus(rowDataLocal._id);
        } else props.showAlert("No data available for selected filters!", "error");
      })
      .catch((err) => props.showAlert(('' + err), "error"));
  };

  const UpdateMessagedStatus = (intwID) => {
    let apiURL = process.env.REACT_APP_API_URL + "/interview/messagedStatus/" + intwID;
    let apiParams = {
      method: "POST",
      headers: {
        updatedbyid: user._id,
        updatedbyname: user.name,
        authtoken: localStorage.getItem("loggedintoken")
      }
    };
    fetch(apiURL, apiParams)
      .then((res) => (res.status === 200 ? res.json() : res.text()))
      .then((repos) => {
        if (!repos.data) props.showAlert("" + (repos.message || repos), "error");
      })
      .catch((err) => props.showAlert(('' + err), "error"));
  };

  const LoadPreviousData = () => {
    let apiParams = {
      method: "GET",
      headers: {
        fromdate: fromDate,
        todate: toDate,
        authtoken: localStorage.getItem("loggedintoken")
      }
    };

    let apiURL = process.env.REACT_APP_API_URL + "/dashboard/searchbydate/" + user._id;

    fetch(apiURL, apiParams)
      .then((res) => (res.status === 200 ? res.json() : res.text()))
      .then((repos) => {
        if (repos.data) {
          const { passed, failed, messaged, pending, notReachable, applied, verified, verificationFailed, verificationPending, verificationAvailable, currentCandidate, idleTime, loggedinTime, callingTime } = repos.data;

          let namesCol = max_of_three(passed, failed, pending, notReachable, verified, verificationFailed, verificationPending, currentCandidate, idleTime, loggedinTime, callingTime);

          setRowData(namesCol.map((name, id) => {
            let idleTimeVal = Math.abs(new Date().getTime() - new Date((idleTime.filter(rec => rec._id === name)[0] || { closedOn: new Date().toISOString() }).closedOn).getTime()) / 1000;
            let openTime = (Math.abs(new Date().getTime() - new Date((currentCandidate.filter(rec => rec.createdbyname === name)[0] || { openedOn: new Date().toISOString() }).openedOn).getTime()) / 1000) + parseInt((currentCandidate.filter(rec => rec.createdbyname === name)[0] || { timeSpent: 0 }).timeSpent);
            openTime = parseInt(openTime) > 0 ? parseInt(openTime) : parseInt(idleTimeVal);

            return {
              id,
              name: name,
              verified: (verified.filter(rec => rec._id === name)[0] || { count: 0 }).count,
              verificationFailed: (verificationFailed.filter(rec => rec._id === name)[0] || { count: 0 }).count,
              verificationPending: (verificationAvailable.filter(rec => rec._id === name)[0] || { count: 0 }).count + "/" + (verificationPending.filter(rec => rec._id === name)[0] || { count: 0 }).count,
              passed: (passed.filter(rec => rec._id === name)[0] || { count: 0 }).count,
              messaged: (messaged.filter(rec => rec._id === name)[0] || { count: 0 }).count,
              failed: (failed.filter(rec => rec._id === name)[0] || { count: 0 }).count,
              called: (passed.filter(rec => rec._id === name)[0] || { count: 0 }).count + (failed.filter(rec => rec._id === name)[0] || { count: 0 }).count,
              pending: (applied.filter(rec => rec._id === name)[0] || { count: 0 }).count + "/" + (pending.filter(rec => rec._id === name)[0] || { count: 0 }).count,
              notReachable: (notReachable.filter(rec => rec._id === name)[0] || { count: 0 }).count,
              currentCandidate: (currentCandidate.filter(rec => rec.createdbyname === name)[0] || { _id: "" }).name,
              interviewid: (currentCandidate.filter(rec => rec.createdbyname === name)[0] || { _id: "" })._id,
              openTime: openTime,
            }
          }));
          setLoadTime(new Date());
        } else props.showAlert(repos.message || repos, "error");
      })
      .catch((err) => props.showAlert(('' + err), "error"));
  }

  const LoadCurrentData = async () => {
    if (fromDate === new Date().toISOString().substring(0, 10) && toDate === new Date().toISOString().substring(0, 10)) {
      let apiParams = {
        method: "GET",
        headers: {
          fromdate: fromDate,
          todate: toDate,
          authtoken: localStorage.getItem("loggedintoken")
        }
      };

      let apiURL = process.env.REACT_APP_API_URL + "/dashboard/searchbydate/" + user._id;

      await fetch(apiURL, apiParams)
        .then((res) => (res.status === 200 ? res.json() : res.text()))
        .then((repos) => {
          if (repos.data) {
            setResult(repos.data.userStatus);
            const {
              passed, failed, pending, notReachable, applied, verificationAvailable,
              verified, verificationFailed, verificationPending, currentCandidate,
              userStatus, idleTime, users, loggedinTime, callingTime
            } = repos.data;
            let newData = users.map((name, id) => {
              let idleTimeVal = Math.abs(new Date().getTime() - new Date((idleTime.find(rec => rec._id === name) || { closedOn: new Date().toISOString() }).closedOn).getTime()) / 1000;
              let openTime = (Math.abs(new Date().getTime() - new Date((currentCandidate.find(rec => rec.createdbyname === name) || { openedOn: new Date().toISOString() }).openedOn).getTime()) / 1000) + parseInt(((currentCandidate.find(rec => rec.createdbyname === name) || { timeSpent: 0 }).timeSpent));
              openTime = parseInt(openTime) > 0 ? parseInt(openTime) : parseInt(idleTimeVal);

              const statusRec = userStatus.find(rec => rec.name === name) || {};
              const loggedInRec = (loggedinTime || []).find(rec => rec._id && rec._id.name === name) || { TotalTime: 0 };
              const callingRec = (callingTime || []).find(rec => rec._id && rec._id.name === name) || { TotalTime: 0 };

              return {
                id,
                name: name,
                verified: (verified.find(rec => rec._id === name) || { count: 0 }).count,
                verificationFailed: (verificationFailed.find(rec => rec._id === name) || { count: 0 }).count,
                verificationPending: (verificationAvailable.find(rec => rec._id === name) || { count: 0 }).count + "/" + (verificationPending.find(rec => rec._id === name) || { count: 0 }).count,
                passed: (passed.find(rec => rec._id === name) || { count: 0 }).count,
                failed: (failed.find(rec => rec._id === name) || { count: 0 }).count,
                called: (passed.find(rec => rec._id === name) || { count: 0 }).count + (failed.find(rec => rec._id === name) || { count: 0 }).count,
                pending: (applied.find(rec => rec._id === name) || { count: 0 }).count + "/" + (pending.find(rec => rec._id === name) || { count: 0 }).count,
                notReachable: (notReachable.find(rec => rec._id === name) || { count: 0 }).count,
                currentCandidate: (currentCandidate.find(rec => rec.createdbyname === name) || { _id: "" }).name,
                userStatus: statusRec.message || "",
                isCallingActive: statusRec.isCallingActive === true || statusRec.isCallingActive === "true" || statusRec.isCallingActive === 1 || statusRec.isCallingActive === "1",
                openTime: openTime,
                interviewid: (currentCandidate.find(rec => rec.createdbyname === name) || { _id: "" })._id,
                loggedInTotal: loggedInRec.TotalTime,
                callingTotal: callingRec.TotalTime
              };
            });

            setRowData(newData);
            setLoadTime(new Date());
          } else props.showAlert(repos.message || repos, "error");
        })
        .catch((err) => props.showAlert(('' + err), "error"))
        .finally(() => setIsLoading(false));
    } else {
      setIsLoading(false);
    }
  };

  const UpdateCallingStatus = () => {
    if (isLoading) return;
    setIsLoading(true);
    if (isCallingActive !== true) {
      startCalling();
    } else {
      stopCalling(user);
    }
  };

  const startCalling = () => {
    let apiURL = process.env.REACT_APP_API_URL + "/usercallingstatus/userstarttime";
    let apiParams = {
      method: "POST",
      headers: {
        iscallingactive: true,
        userid: user._id,
        username: user.name,
        authtoken: localStorage.getItem("loggedintoken")
      },
    };
    fetch(apiURL, apiParams)
      .then((res) => (res.status === 200 ? res.json() : res.text()))
      .then((repos) => {
        if (repos.data) {
          setUserStatusId(repos.data._id || repos.data.status_id);
          setIsCallingActive(true);
        } else {
          props.showAlert("" + (repos.message || repos), "error");
          setIsLoading(false);
        }
      })
      .catch((err) => {
        props.showAlert(('' + err), "error");
        setIsLoading(false);
      });
  };

  const stopCalling = (activeUser, overrideComment = null) => {
    if (activeUser) {
      if (!userStatusId) {
        props.showAlert("Error: Status ID missing. Please refresh the page.", "error");
        setIsLoading(false);
        setOpenStopModel(false);
        return;
      }

      setIsLoading(true);
      setOpenStopModel(false);

      const commentToUse = overrideComment !== null ? overrideComment : stopComments;

      let apiURL = process.env.REACT_APP_API_URL + "/usercallingstatus/userstoptime/" + userStatusId;
      let apiParams = {
        method: "POST",
        headers: {
          iscallingactive: false,
          userid: activeUser._id,
          username: activeUser.name,
          stopcomments: encodeURIComponent(commentToUse),
          authtoken: localStorage.getItem("loggedintoken")
        },
      };
      fetch(apiURL, apiParams)
        .then((res) => (res.status === 200 ? res.json() : res.text()))
        .then((repos) => {
          if (repos.data) {
            setIsCallingActive(false);
            hasStartedCalling.current = false;
            props.showAlert("Calling is Stopped!!", "success");
          } else {
            props.showAlert("" + (repos.message || repos), "error");
          }
        })
        .catch((err) => props.showAlert(('' + err), "error"))
        .finally(() => setIsLoading(false));
    }
  };

  const closeStopModel = () => setOpenStopModel(false);

  const currentUserData = rowData?.find(x => x.name === user?.name);

  // =========================================================
  // ✅ 3. UPDATE REFS & STABLE CALLBACKS
  // =========================================================

  useEffect(() => {
    loadCurrentDataRef.current = LoadCurrentData;
    showCandidateRef.current = showCandidate;
    msgCandidateRef.current = msgCandidate;
  });

  const handleRefreshStable = useCallback(() => {
    if (loadCurrentDataRef.current) loadCurrentDataRef.current();
  }, []);

  const handleCloseScheduleStable = useCallback((openNext) => {
    if (loadCurrentDataRef.current) loadCurrentDataRef.current();
    setOpenScedule(false);
    alertStart.current = new Date();
    setTimeout(checkIdle, 300000);
    if (openNext && showCandidateRef.current) showCandidateRef.current("new", user.name);
  }, [user.name]);

  const handleCloseApplicantStable = useCallback(() => {
    setOpenApplicant(false);
  }, []);

  const handleShowCandidateStable = useCallback((candidate, hr) => {
    if (showCandidateRef.current) showCandidateRef.current(candidate, hr);
  }, []);

  const handleMsgCandidateStable = useCallback((candidate, hr) => {
    if (msgCandidateRef.current) msgCandidateRef.current(candidate, hr);
  }, []);


  // =========================================================
  // ✅ 4. ISOLATED EFFECTS (Live Hardware Trackers & Timers)
  // =========================================================

  useEffect(() => {
    LoadCurrentData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (!openShedule) {
        if (loadCurrentDataRef.current) loadCurrentDataRef.current();
      }
    }, 15000);

    return () => clearInterval(intervalId);
  }, [openShedule]);

  // Synchronize the local session timer with API `loggedInTotal` smoothly
  useEffect(() => {
    if (currentUserData?.loggedInTotal !== undefined) {
      const apiSeconds = Math.floor(currentUserData.loggedInTotal * 60);
      setSessionSeconds(prev => {
        // Prevent UI jitter: only override if out of sync by more than 15 seconds
        if (Math.abs(prev - apiSeconds) > 15) {
          return apiSeconds;
        }
        return prev;
      });
    }
  }, [currentUserData?.loggedInTotal]);

  // Local ticker for the Session Timer UI (Only ticks when isCallingActive is true)
  useEffect(() => {
    let timerInterval = null;
    if (isCallingActive) {
      timerInterval = setInterval(() => {
        setSessionSeconds(prev => prev + 1);
      }, 1000);
    }
    return () => {
      if (timerInterval) clearInterval(timerInterval);
    };
  }, [isCallingActive]);

  useEffect(() => {
    const activeRes = result.find((res) => res.user_id === user._id || res.name === user.name);
    if (activeRes) {
      const isActive = activeRes.isCallingActive === true || activeRes.isCallingActive === "true" || activeRes.isCallingActive === 1 || activeRes.isCallingActive === "1";
      setIsCallingActive(isActive);

      if (activeRes.status_id) {
        setUserStatusId(activeRes.status_id);
      } else if (activeRes._id) {
        setUserStatusId(activeRes._id);
      }
    }
  }, [result, user]);

  useEffect(() => {
    if (isCallingActive) {
      if (!micAllowed) {
        const msg = "Stopped since microphone is muted/unavailable!";
        alert("Your microphone is muted or unavailable!");
        setStopComments(msg);
        stopCalling(user, msg);
      } else if (!hasStartedCalling.current) {
        navigator.mediaDevices.getUserMedia({
          audio: {
            autoGainControl: true,
            echoCancellation: true,
            noiseSuppression: true
          }
        })
          .then(async (stream) => {
            const track = stream.getAudioTracks()[0];
            try { await track.applyConstraints({ advanced: [{ volume: 1.0 }] }); } catch (e) { }
            alertStart.current = new Date();
            setTimeout(() => checkIdle(), 300000);
            hasStartedCalling.current = true;
            props.showAlert("Calling Started!!", "success");
          })
          .catch(err => {
            console.error(err);
          });
      }
    } else {
      hasStartedCalling.current = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCallingActive, micAllowed]);

  useEffect(() => {
    if (!openStopModel) {
      setStopComments("");
    }
  }, [openStopModel]);

  // =========================================================
  // ✅ 5. LIVE HARDWARE & PERMISSIONS MONITOR
  // =========================================================
  const requestPermissionsManually = useCallback(async () => {
    let activeStream = null;
    let micPermissionStatus = null;
    let camPermissionStatus = null;

    const stopActiveStream = () => {
      if (activeStream) {
        activeStream.getTracks().forEach(t => {
          t.onmute = null;
          t.onunmute = null;
          t.onended = null;
          t.stop();
        });
        activeStream = null;
      }
    };

    const monitorHardware = async () => {
      try {
        stopActiveStream();
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true, video: false });
        activeStream = stream;
        const track = stream.getAudioTracks()[0];

        const updateState = () => {
          const isLiveAndUnmuted = track.readyState === 'live' && !track.muted;
          setMicAllowed(isLiveAndUnmuted);
          micAllowedRef.current = isLiveAndUnmuted;
        };

        updateState();
        track.onmute = updateState;
        track.onunmute = updateState;

        track.onended = () => {
          setMicAllowed(false);
          micAllowedRef.current = false;
          stopActiveStream();
        };

      } catch (err) {
        setMicAllowed(false);
        micAllowedRef.current = false;
      }
    };

    try {
      camPermissionStatus = await navigator.permissions.query({ name: "camera" });
      setCamAllowed(camPermissionStatus.state === "granted");
      camPermissionStatus.onchange = () => {
        setCamAllowed(camPermissionStatus.state === "granted");
      };

      micPermissionStatus = await navigator.permissions.query({ name: "microphone" });

      if (micPermissionStatus.state === 'granted') {
        monitorHardware();
      } else {
        setMicAllowed(false);
        micAllowedRef.current = false;
        if (micPermissionStatus.state === 'prompt') {
          monitorHardware();
        }
      }

      micPermissionStatus.onchange = () => {
        if (micPermissionStatus.state === 'granted') {
          monitorHardware();
        } else {
          setMicAllowed(false);
          micAllowedRef.current = false;
          stopActiveStream();
        }
      };
    } catch (err) {
      monitorHardware();
    }

    const handleDeviceChange = () => {
      if (micPermissionStatus?.state === 'granted' || !micPermissionStatus) {
        monitorHardware();
      }
    };

    navigator.mediaDevices.addEventListener('devicechange', handleDeviceChange);

    return () => {
      navigator.mediaDevices.removeEventListener('devicechange', handleDeviceChange);
      if (camPermissionStatus) camPermissionStatus.onchange = null;
      if (micPermissionStatus) micPermissionStatus.onchange = null;
      stopActiveStream();
    };
  }, []);

  useEffect(() => {
    const cleanup = requestPermissionsManually();
    return () => {
      cleanup.then(cleanFn => {
        if (typeof cleanFn === 'function') cleanFn();
      });
    };
  }, [requestPermissionsManually]);


  // =========================================================
  // ✅ 6. AUTO-CLOSE SCHEDULE INTERVIEW IF MIC IS LOST
  // =========================================================
  useEffect(() => {
    if (!micAllowed && openShedule) {
      setOpenScedule(false);
      props.showAlert("Interview closed because microphone access was revoked or muted.", "error");
    }
  }, [micAllowed, openShedule, props]);


  return (
    <>
      {camAllowed && micAllowed ? (
        <div style={{ width: "100%", height: "100%" }}>
          {!settingFilter && (
            <div id="Empoyee_Dashi_Mobemployee_dashboard">

              <div id="Empoyee_Dashi_MobGroup_8" onClick={() => setChattingView(true)}>
                <svg className="Empoyee_Dashi_Mobchat_btn">
                  <ellipse id="Empoyee_Dashi_Mobchat_btn" rx="20" ry="20" cx="20" cy="20" />
                </svg>
                <img id="Empoyee_Dashi_Mobchat_lbl" src="chat_lbl.png" alt="Chat" />
              </div>

              {/* NAME ON LEFT, TIMER ON RIGHT */}
              <div id="Empoyee_Dashi_MobGroup_11" style={{ width: '100%', display: 'flex' }}>
                <div id="Empoyee_Dashi_Mobuser_name_lbl" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: 'calc(100% - 45px)', whiteSpace: 'nowrap' }}>
                  <span>{user.name}</span>
                  <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#14c871', letterSpacing: 'normal' }} onClick={(e) => {
                    e.stopPropagation(); // Prevents triggering the row's onCellClick
                    setReportUserId(user._id);
                    setReportUserName(user.name);
                    setReportOpen(true);
                  }}>
                    ⏱ Logged-in: {formatSessionTimer(sessionSeconds)}
                  </span>
                </div>
              </div>

              <div id="Empoyee_Dashi_MobGroup_13">
                <svg className="Empoyee_Dashi_Mobcall_time_outer_line">
                  <rect id="Empoyee_Dashi_Mobcall_time_outer_line" rx="29" ry="29" width="163" height="163" />
                </svg>
                <div id="Empoyee_Dashi_MobCallIdle_Time_lbl">
                  <span>Call/Idle Time</span>
                </div>
                <img id="Empoyee_Dashi_Mobtime-call_img" src="time-call_img.png" alt="Call Time" />
                <div id="Empoyee_Dashi_MobGroup_22">
                  <svg className="Empoyee_Dashi_Mobcall_time_val">
                    <rect id="Empoyee_Dashi_Mobcall_time_val" rx="18.5" ry="18.5" width="150" height="37" />
                  </svg>
                  <div id="Empoyee_Dashi_Mobn_">
                    <span>
                      {currentUserData && (() => {
                        const callingMins = currentUserData.callingTotal || 0;
                        const loggedInMins = currentUserData.loggedInTotal || 0;
                        const idleMins = Math.max(0, loggedInMins - callingMins);

                        const formatHHMM = (totalMins) => {
                          const h = Math.floor(totalMins / 60);
                          const m = Math.floor(totalMins % 60);
                          return `${String(h)}:${String(m).padStart(2, '0')}`;
                        };

                        const isIdleHigh = callingMins < idleMins;

                        return (
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                            <span>{formatHHMM(callingMins)}</span>
                            <span style={{ margin: '0 4px' }}>/</span>
                            <span className={isIdleHigh ? "blink-red" : ""}>
                              {formatHHMM(idleMins)}
                            </span>
                          </div>
                        );
                      })()}
                    </span>
                  </div>
                </div>
              </div>
              <div id="Empoyee_Dashi_MobGroup_18">
                <svg className="Empoyee_Dashi_Mobverified_outer_line">
                  <rect id="Empoyee_Dashi_Mobverified_outer_line" rx="29" ry="29" width="163" height="163" />
                </svg>
                <div id="Empoyee_Dashi_MobVerified_lbl"><span>Verification Pending</span></div>
                <img id="Empoyee_Dashi_Mobverified_img" src="verified_img.png" alt="Verification" />
                <div id="Empoyee_Dashi_MobGroup_23">
                  <svg className="Empoyee_Dashi_Mobverified_val">
                    <rect id="Empoyee_Dashi_Mobverified_val" rx="18.5" ry="18.5" width="117" height="37" />
                  </svg>
                  <div id="Empoyee_Dashi_Mobn__">
                    <span>
                      {currentUserData && (
                        <a href={`/interviewdetails?selectedCell=verificationPending,${user._id},${currentUserData.name},${fromDate},${toDate}`}>
                          {currentUserData.verificationPending}
                        </a>
                      )}
                    </span>
                  </div>
                </div>
              </div>

              <div id="Empoyee_Dashi_MobGroup_16">
                <svg className="Empoyee_Dashi_MobRectangle_10">
                  <rect id="Empoyee_Dashi_MobRectangle_10" rx="29" ry="29" width="163" height="163" />
                </svg>
                <div id="Empoyee_Dashi_MobCalled"><span>Interviewed/Not Reached</span></div>
                <img id="Empoyee_Dashi_Mobcustomer-service1" src="customer-service1.png" alt="Service" />
                <div id="Empoyee_Dashi_MobGroup_20">
                  <svg className="Empoyee_Dashi_Mobcalled_val">
                    <rect id="Empoyee_Dashi_Mobcalled_val" rx="18.5" ry="18.5" width="117" height="37" />
                  </svg>
                  <div id="Empoyee_Dashi_Mobn__bb">
                    <span>
                      {currentUserData && (
                        <>
                          <a href={`/interviewdetails?selectedCell=called,${user._id},${currentUserData.name},${fromDate},${toDate}`}>
                            {currentUserData.called}
                          </a> /
                          <a href={`/interviewdetails?selectedCell=notReachable,${user._id},${currentUserData.name},${fromDate},${toDate}`}>
                            {currentUserData.notReachable}
                          </a>
                        </>
                      )}
                    </span>
                  </div>
                </div>
              </div>

              <div id="Empoyee_Dashi_MobGroup_15">
                <svg className="Empoyee_Dashi_MobRectangle_11">
                  <rect id="Empoyee_Dashi_MobRectangle_11" rx="29" ry="29" width="163" height="163" />
                </svg>
                <div id="Empoyee_Dashi_MobAvailable"><span>Fresh / Existing</span></div>
                <img id="Empoyee_Dashi_Mobavailable" src="available.png" alt="Available" />
                <div id="Empoyee_Dashi_MobGroup_21">
                  <svg className="Empoyee_Dashi_Mobavailable_val">
                    <rect id="Empoyee_Dashi_Mobavailable_val" rx="18.5" ry="18.5" width="117" height="37" />
                  </svg>
                  <div id="Empoyee_Dashi_Mobn__bi">
                    <span>{currentUserData?.pending}</span>
                  </div>
                </div>
              </div>

              <div id="Empoyee_Dashi_MobGroup_14">
                <svg className="Empoyee_Dashi_MobRectangle_8">
                  <rect id="Empoyee_Dashi_MobRectangle_8" rx="29" ry="29" width="163" height="163" />
                </svg>
                <img id="Empoyee_Dashi_Mobfailed_img" src="failed_img.png" alt="Failed" />
                <img id="Empoyee_Dashi_Mobpassed_img" src="passed_img.png" alt="Passed" />

                <div id="Empoyee_Dashi_MobGroup_1">
                  <svg className="Empoyee_Dashi_Mobpassed_val">
                    <rect id="Empoyee_Dashi_Mobpassed_val" rx="18.5" ry="18.5" width="52" height="37" />
                  </svg>
                  <div id="Empoyee_Dashi_Mobn__bp">
                    <span>
                      {currentUserData && (
                        <a href={`/interviewdetails?selectedCell=passed,${user._id},${currentUserData.name},${fromDate},${toDate}`}>
                          {currentUserData.passed}
                        </a>
                      )}
                    </span>
                  </div>
                </div>

                <div id="Empoyee_Dashi_MobGroup_2">
                  <svg className="Empoyee_Dashi_Mobpassed_val_br">
                    <rect id="Empoyee_Dashi_Mobpassed_val_br" rx="18.5" ry="18.5" width="52" height="37" />
                  </svg>
                  <div id="Empoyee_Dashi_Mobn__bs">
                    <span>
                      {currentUserData && (
                        <a href={`/interviewdetails?selectedCell=failed,${user._id},${currentUserData.name},${fromDate},${toDate}`}>
                          {currentUserData.failed}
                        </a>
                      )}
                    </span>
                  </div>
                </div>
                <div id="Empoyee_Dashi_MobHR_Screening_"><span>HR Screening</span></div>
              </div>

              <div id="Empoyee_Dashi_MobGroup_17">
                <svg className="Empoyee_Dashi_MobRectangle_9">
                  <rect id="Empoyee_Dashi_MobRectangle_9" rx="29" ry="29" width="163" height="163" />
                </svg>
                <div id="Empoyee_Dashi_MobVerification_"><span>Verification</span></div>
                <img id="Empoyee_Dashi_Mobverification_failed_img" src="verification_failed_img.png" alt="Verification Failed" />
                <img id="Empoyee_Dashi_Mobverification_pending_img" src="verification_pending_img.png" alt="Verification Pending" />

                <div id="Empoyee_Dashi_MobGroup_3">
                  <svg className="Empoyee_Dashi_Mobpassed_val_b">
                    <rect id="Empoyee_Dashi_Mobpassed_val_b" rx="18.5" ry="18.5" width="52" height="37" />
                  </svg>
                  <div id="Empoyee_Dashi_Mobn__b">
                    <span>
                      {currentUserData && (
                        <a href={`/interviewdetails?selectedCell=verified,${user._id},${currentUserData.name},${fromDate},${toDate}`}>
                          {currentUserData.verified}
                        </a>
                      )}
                    </span>
                  </div>
                </div>

                <div id="Empoyee_Dashi_MobGroup_4">
                  <svg className="Empoyee_Dashi_Mobpassed_val_ca">
                    <rect id="Empoyee_Dashi_Mobpassed_val_ca" rx="18.5" ry="18.5" width="52" height="37" />
                  </svg>
                  <div id="Empoyee_Dashi_Mobn__ca">
                    <span>
                      {currentUserData && (
                        <a href={`/interviewdetails?selectedCell=verificationFailed,${user._id},${currentUserData.name},${fromDate},${toDate}`}>
                          {currentUserData.verificationFailed}
                        </a>
                      )}
                    </span>
                  </div>
                </div>
              </div>

              <div id="Empoyee_Dashi_MobGroup_19">
                <svg className="Empoyee_Dashi_Mobdashboard_profile_outer_line">
                  <rect id="Empoyee_Dashi_Mobdashboard_profile_outer_line" rx="20" ry="20" width="379" height="103" />
                </svg>
                <div id="Empoyee_Dashi_MobGroup_7">
                  {isCallingActive ? (
                    <div>
                      {currentUserData && (
                        <>
                          <div>
                            <ContactButton type="CALL" user={user} rowData={rowData} onAction={handleShowCandidateStable} />
                          </div>
                          <div>
                            <ContactButton type="WHATSAPP" user={user} rowData={rowData} onAction={handleMsgCandidateStable} />
                          </div>
                        </>
                      )}
                    </div>
                  ) : (
                    (stopComments || currentUserData?.userStatus) && (
                      <div className="stopComments_mob">
                        <marquee>{stopComments || currentUserData.userStatus}</marquee>
                      </div>
                    )
                  )}
                  <img id="Empoyee_Dashi_Mobsetting" src="setting.png" alt="Settings" onClick={() => setSettingFilter(true)} />
                </div>
                <div id="Empoyee_Dashi_MobGroup_12">
                  <div id="Empoyee_Dashi_MobCurrent_Candidate_lbl">
                    <span>Candidate:{currentUserData?.currentCandidate ? <marquee id="Empoyee_Dashi_MobCurrent_Candidate_val">{currentUserData.currentCandidate}</marquee> : "None"}</span>
                  </div>
                  {!isLoading && (
                    <img
                      id="Empoyee_Dashi_Mobwhatsapp_dashboard_cd"
                      src={isCallingActive ? "stop-button_mob.png" : "whatsapp_dashboard_cd.png"}
                      alt="Status Toggle"
                      onClick={() => isCallingActive ? setOpenStopModel(true) : UpdateCallingStatus()}
                    />
                  )}
                </div>
              </div>


              <div id="Empoyee_Dashi_MobGroup_10" onClick={addApplicants}>
                <svg className="Empoyee_Dashi_Mobchat_btn_cf">
                  <ellipse id="Empoyee_Dashi_Mobchat_btn_cf" rx="20" ry="20" cx="20" cy="20" />
                </svg>
                <img id="Empoyee_Dashi_Mobchat_lbl_cg" src="chat_lbl_cg.png" alt="Chat Action" />
              </div>

              <div id="Empoyee_Dashi_MobGroup_26">
                <select className="Empoyee_Dashi_MobRectangle_43" value={data} onChange={(e) => setData(e.target.value)}>
                  <option value="history">History</option>
                  <option value="mobile">Mobile</option>
                  <option value="name">Name</option>
                  <option value="feedback">Feedback</option>
                  <option value="language">Language</option>
                  <option value="area">Location</option>
                  <option value="education">Education</option>
                </select>

                <div id="Empoyee_Dashi_MobGroup_25">
                  {data !== 'history' ? (
                    <input className="Empoyee_Dashi_MobRectangle_44" value={searchData} onChange={(e) => setSearchData(e.target.value)} />
                  ) : (
                    <>
                      <input type="date" className="inputfield" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />&nbsp;
                      <input type="date" className="inputfield" value={toDate} onChange={(e) => setToDate(e.target.value)} />
                    </>
                  )}
                  <img id="Empoyee_Dashi_Mobchat_lbl_cl" src="chat_lbl_cl.png" alt="Search" onClick={data !== 'history' ? SearchCandidate : LoadPreviousData} />
                </div>
              </div>

              {user && parseInt(user.accesstype) > 1 && (
                <div id="Empoyee_Dashi_MobGroup_24">
                  <div className="Empoyee_Dashi_MobRectangle_45">
                    <Switch
                      id="Empoyee_Dashi_MobRectangle_45"
                      checked={activeAdmin}
                      onChange={(e) => {
                        setActiveAdmin(e.target.checked);
                        setTimeout(() => props.showHr("Admin"), 1000);
                      }}
                      inputProps={{ 'aria-label': 'controlled' }}
                    />
                  </div>
                  <div id="Empoyee_Dashi_MobAdmin"><span>Supervisor</span></div>
                </div>
              )}
            </div>
          )}

          {settingFilter && <FilterInterviewsMob setfilter={true} filter={(value) => setSettingFilter(value)} />}
          {chattingView && <EmployeeChats chatsopen={true} chats={(e) => setChattingView(e)} />}

          <Modal
            open={openStopModel}
            onClose={closeStopModel}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={{ overflow: 'scroll', textAlign: "center" }}
          >
            <Box sx={stopModalStyle}>
              <Typography component="div" id="modal-modal-description">
                <Container style={{ padding: "0px" }}>
                  <div className="content6">
                    <div style={{ alignItems: "center" }}>
                      <h2 className='fnt2' style={{ left: 0, top: 0 }}><b>Enter Stop Reason</b></h2>
                      <Button title="Close" variant="Standard" sx={{ float: "right", right: 0, top: 0, position: "absolute", height: 35, width: 5, color: "white", backgroundColor: "red" }} onClick={closeStopModel}><CloseIcon /></Button>
                    </div>
                    <br />
                    <TextField id="stopReason" multiline rows={3} sx={{ m: 1, width: '35ch' }} size="small" label="Enter Stop Reason" variant="outlined" value={stopComments} onChange={(e) => setStopComments(e.target.value)} />
                    <br />
                    <Button variant="contained" sx={{ m: 1, width: '35ch', backgroundColor: "#14c871" }} onClick={() => { stopComments.trim().length > 0 ? UpdateCallingStatus() : props.showAlert("Please Enter Stop Reason!!!", "error"); }}>Submit</Button>
                  </div>
                </Container>
              </Typography>
            </Box>
          </Modal>

          {/* HIDDEN MODALS ARE CONDITIONALLY MOUNTED TO STOP CASCADING BACKGROUND API SPAM */}
          {openShedule && (
            <ScheduleInterviewUI
              open={openShedule}
              showAlert={props.showAlert}
              interview={selectedRow}
              refresh={handleRefreshStable}
              close={handleCloseScheduleStable}
            />
          )}

          {openApplicant && (
            <ApplicantPopup
              open={openApplicant}
              showAlert={props.showAlert}
              close={handleCloseApplicantStable}
            />
          )}
        </div>
      ) : (
        <div style={{ padding: "20px", textAlign: "center", display: "flex", flexDirection: "column", gap: "15px" }}>
          <h3>Permissions Required</h3>
          <p>You need to grant Camera and Microphone Permissions to use this Page!</p>
          <Button
            variant="contained"
            color="primary"
            onClick={requestPermissionsManually}
            sx={{ padding: "10px", fontWeight: "bold" }}
          >
            Grant Permissions Again
          </Button>
        </div>
      )}

      {/* Persistent warning banners */}
      {!camAllowed && (
        <div style={{ color: 'yellow', backgroundColor: "red", textAlign: "center", padding: "5px", position: "fixed", bottom: 0, width: "100%", zIndex: 9999 }}>
          Please grant Camera Permissions!
        </div>
      )}
      {!micAllowed && (
        <div style={{ color: 'yellow', backgroundColor: "red", textAlign: "center", padding: "5px", position: "fixed", bottom: camAllowed ? 0 : 30, width: "100%", zIndex: 9999 }}>
          Please grant Microphone Permissions!
        </div>
      )}
      <TimeUtilizationReport
        open={reportOpen}
        onClose={() => setReportOpen(false)}
        userId={reportUserId}
        userName={reportUserName}
      />
    </>
  );
}

export default EmployeeDashboardMob;